var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"feedback",attrs:{"href":"https://jinshuju.net/f/H5bn5B"}},[_vm._v("意见反馈")])])}]

export { render, staticRenderFns }